//TASK_COMPLETED
export const TASK_COMPLETED_REQUEST = "TASK_COMPLETED_REQUEST";
export const TASK_COMPLETED_SUCCESS = "TASK_COMPLETED_SUCCESS";
export const TASK_COMPLETED_FAIL = "TASK_COMPLETED_FAIL";

//GET_ALL_ONBOARDING_TASKS
export const GET_ALL_ONBOARDING_TASKS_REQUEST =
  "GET_ALL_ONBOARDING_TASKS_REQUEST";
export const GET_ALL_ONBOARDING_TASKS_SUCCESS =
  "GET_ALL_ONBOARDING_TASKS_SUCCESS";
export const GET_ALL_ONBOARDING_TASKS_FAIL = "GET_ALL_ONBOARDING_TASKS_FAIL";

// supportCardTypes.js

export const TOGGLE_SUPPORT_CARD = "TOGGLE_SUPPORT_CARD";
